<template>
  <div
    :title="big ? '' : titleText"
    :class="{
      'f-message-counter': true,
      'f-message-counter-unread': !item.read,
      'f-message-counter-big': big,
      'f-message-counter-disabled': item.disabled
    }">
    <f-icon :name="item.type" />
    <span class="f-message-counter-value counter">{{ item.counter }}</span>
  </div>
</template>
<script>

export default {
  name: 'f-message-counter',
  props: {
    item: {
      type: Object,
      default() {
        return {
          counter: '',
          type: '',
          read: true,
          disabled: false
        }
      },
      required: true
    },
    big: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleText () {
      let output = [this.$t('ui.youHave')];

      if (this.item.type === 'mail') {
        output.push(this.$tc('message.messageForCounter', this.item.counter));
        if (!this.item.read) {
          output.push(this.$tc('ui.unread', this.item.counter));
        }

        return output.join(' ');
      }

      output.push(this.$tc('inquiry.inquiryForCounter', this.item.counter));

      if (!this.item.read) {
        output.push(this.$tc('ui.needsInteraction', this.item.counter));
      }

      return output.join(' ');
    }
  }
}
</script>
